import { Navigate } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';
import LegalPage from '@containers/legal-page';

const commonRoutes: RouteObject[] = [
  {
    path: '/privacy',
    element: <LegalPage />,
  },
  {
    path: '/terms',
    element: <LegalPage />,
  },
  {
    path: '*',
    element: <Navigate to="/" />,
  },
];

export default commonRoutes;
